import { SeriesNavMenuDesktop } from './SeriesNavMenuDesktop'

export const SeriesNavMenu = () => {
  return <NavMenu.Desktop />
}

const NavMenu = {
  Desktop: SeriesNavMenuDesktop,
  Mobile: SeriesNavMenuDesktop,
}